// Personalization preview (V_DH_PDP_01 winner — Var B)
// Mirrors the name/phone inputs onto the preview image live as the shopper
// types. Purely cosmetic — the inputs themselves already submit as line
// item properties via their `name` attributes, no cart-side JS needed here.
(() => {
  const initPersonalize = () => {
    const preview = document.querySelector('[data-c-vdhpdp01-preview]');
    if (!preview || preview.dataset.vdhpdp01Init) return;
    preview.dataset.vdhpdp01Init = '1';

    // The theme's real personalization inputs (sections/main-product.liquid)
    // — not created here, just read from.
    const nameInput = document.getElementById('custom-name-control');
    const phoneInput = document.getElementById('custom-phone-control');
    const nameLabel = preview.querySelector('[data-c-vdhpdp01-preview-name]');
    const phoneLabel = preview.querySelector('[data-c-vdhpdp01-preview-phone]');

    // Shrinks the name label with a fixed step-down so a long name still
    // fits inside the strap width instead of overflowing it. Reads the
    // CSS-defined size first (rather than a hardcoded number) since
    // assets/c-v-dh-pdp-01.css sets a different base size per breakpoint.
    const fitName = () => {
      if (!nameLabel) return;
      nameLabel.style.fontSize = '';
      // cqw is relative to `preview` (the container-type: inline-size
      // ancestor), not nameLabel's immediate parent (.overlay).
      const baseSizeCqw = parseFloat(getComputedStyle(nameLabel).fontSize) /
        (preview.clientWidth / 100);
      const maxWidth = nameLabel.parentElement.clientWidth;
      let scale = 1;
      while (nameLabel.scrollWidth > maxWidth && scale > 0.4) {
        scale -= 0.05;
        nameLabel.style.fontSize = `${scale * baseSizeCqw}cqw`;
      }
    };

    // Patch only has room for a name roughly the length of "Jacky Jacky" —
    // beyond that, hard-cut instead of shrinking the font down to something
    // unreadable. No "..." — it ate into the same limited space it was
    // meant to signal, so a straight cutoff fits a couple more characters.
    // The real #custom-name-control input keeps whatever the shopper actually
    // typed; this only affects the image preview.
    const MAX_PATCH_NAME_LENGTH = 12;

    const syncName = () => {
      if (!nameInput || !nameLabel) return;
      const name = nameInput.value.trim().toUpperCase().slice(0, MAX_PATCH_NAME_LENGTH);
      nameLabel.textContent = name;
      fitName();
    };

    const syncPhone = () => {
      if (!phoneInput || !phoneLabel) return;
      phoneLabel.textContent = phoneInput.value.trim();
    };

    // Delegated on document (not bound to the inputs directly) so this runs
    // in the bubble phase, after main-product.liquid's own document-level
    // 'input' listener has already reformatted #custom-phone-control's value
    // (###-###-####) — reading it directly off the input would race that
    // formatter and show the pre-format keystroke.
    document.addEventListener('input', (e) => {
      if (e.target === nameInput) syncName();
      if (e.target === phoneInput) syncPhone();
    });
    window.addEventListener('resize', fitName);

    syncName();
    syncPhone();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPersonalize);
  } else {
    initPersonalize();
  }
})();
